import { FC } from 'react';
import { PaymentFailedOperation } from 'interfaces/stripe';
import { convertSnakeCaseToReadable } from 'utils/common';

interface FailedDetailProps {
  reason: string;
  operation?: PaymentFailedOperation | null;
}

const FAILED_OPERATION_LABEL = {
  [PaymentFailedOperation.CAPTURE]: 'Charge payment',
  [PaymentFailedOperation.RELEASE]: 'Release hold',
  [PaymentFailedOperation.NO_SHOW_FEE]: 'Charge no-show fee',
  [PaymentFailedOperation.REFUND]: 'Refund',
};

const FailedDetail: FC<FailedDetailProps> = ({ reason }) => {
  return (
    <div className="mt-0.4">
      <div className="text-14 text-darkest-grey">
        Failed {convertSnakeCaseToReadable(reason).toLowerCase()}
      </div>
    </div>
  );
};

const FailedDetailTooltip: FC<FailedDetailProps> = ({ operation, reason }) => {
  const operationLabel = operation
    ? FAILED_OPERATION_LABEL[operation]
    : 'Not provided';

  return (
    <div className="flex flex-col gap-y-0.4 text-11 font-normal normal-case leading-[1.6rem]">
      <div className="flex gap-x-1">
        <span className="w-10 shrink-0 text-mid-grey">Status</span>
        <span className="text-darkest-grey">Failed</span>
      </div>
      <div className="flex gap-x-1">
        <span className="w-10 shrink-0 text-mid-grey">Transaction Type</span>
        <span className="text-darkest-grey">{operationLabel}</span>
      </div>
      <div className="flex gap-x-1">
        <span className="w-10 shrink-0 text-mid-grey">Reason</span>
        <span className="text-darkest-grey">
          {convertSnakeCaseToReadable(reason)}
        </span>
      </div>
    </div>
  );
};

export { FailedDetailTooltip };
export default FailedDetail;
